import { type ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import { AlertDialogFooter as AlertDialogFooterBase } from "./base/AlertDialogBase"

export type AlertDialogFooterProps = ComponentProps<
  typeof AlertDialogFooterBase
>

function AlertDialogFooter(props: AlertDialogFooterProps) {
  const { className, ...alertDialogFooterBaseProps } = props
  return (
    <AlertDialogFooterBase
      className={cn("ui-alert-dialog-footer", className)}
      {...alertDialogFooterBaseProps}
    />
  )
}

export default AlertDialogFooter
